import React, { useEffect, useState } from "react";
import MyProfileDetails from "../MyProfileDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateUserDetails, getCurrentUser, getLoggedUserDetails,
  getPicUpdatedStatus,
  getUserProfilePic,
  getUserUpdateStatus, loadUserDetails,
  loadUserProfilePic,
  updateUserProfilePic,
  userDetailsUpdated,
  userProfilePicUpdated
} from "../../app/store/auth";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getAlert } from "../../services/appAlerts";
import { Modal } from "react-bootstrap";

const formatUSPhoneNumber = (phoneNo) => {
  if (!phoneNo) return "";
  const cleaned = ("" + phoneNo).replace(/\D/g, "");
  const match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[2]}) ${match[3]}-${match[4]}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phoneNo;
};

const PartnerProfile = (props) => {
  const { profileShowHide, handleProfileShowHide } = props;


  const [profileEdit, setProfileEdit] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [profilePicObj, setProfilePicObj] = useState(null);
  const [profilePicData, setProfilePicData] = useState(null);

  const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
  const updateStatusSelector = useSelector(getUserUpdateStatus)
  const picUpdatedStatusSelector = useSelector(getPicUpdatedStatus);
  const userProfilePicSelector = useSelector(getUserProfilePic);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(setCurrentPageTitle("My Profile"));
    dispatch(setCurrentRoute([]));
    dispatch(userProfilePicUpdated(true))
  }, [])

  useEffect(() => {
    if (currentUser?.id) {
      dispatch(loadUserDetails(currentUser.id));
    }
  }, []);

  useEffect(() => {
    if (loggedUserDetailsSelector)
      setUserDetails(loggedUserDetailsSelector);
  }, [loggedUserDetailsSelector])

  useEffect(() => {
    if (userProfilePicSelector) {
      //let objectURL = 'data:image/jpeg;base64,' + userProfilePicSelector;
      setProfilePicData(userProfilePicSelector);
    }
  }, [userProfilePicSelector])

  useEffect(() => {
    if (updateStatusSelector === "success" && currentUser?.id) {
      getAlert("", "Updated Successfully", "success");
      // dispatch(loadUserDetails(currentUser.id));
    } else if (updateStatusSelector === "fail") {
      getAlert("", "Update Failed", "error");
    }
    dispatch(loadUserDetails(currentUser.id));
    return () => {
      dispatch(userDetailsUpdated(null));
    }
  }, [updateStatusSelector])


  const handleSubmit = async (profile) => {
    dispatch(UpdateUserDetails(profile));
    handleUpdatePic();
    dispatch(loadUserDetails(currentUser.id));
  };

  const handleUpdatePic = () => {
    const frmData = new FormData();
    frmData.append("userId", currentUser?.id);
    frmData.append("files[0]", profilePicObj?.file);
    dispatch(updateUserProfilePic(frmData));
  }

  useEffect(() => {
    if (picUpdatedStatusSelector) {
      dispatch(loadUserProfilePic(currentUser.id));
    }
  }, [picUpdatedStatusSelector])

  const handleImageChange = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      setProfilePicObj({
        file: file,
        fileName: file.name,
        imagePreviewUrl: reader.result,
      })
    };

    reader.readAsDataURL(file);
  };

  const handleEditProfile = () => {
    setProfileEdit(!profileEdit);
  };

  let $imagePreview = null;
  if (profilePicObj) {
    $imagePreview = <img src={profilePicObj.imagePreviewUrl}
      alt="profile" className="img-thumbnail rounded-circle profilePrev" />
  } else {
    $imagePreview = <img
      alt="profile" className="img-thumbnail rounded-circle profilePrev"
      src={`${!profilePicData ? "../../assets/img/theme/team-4.png" : process?.env?.REACT_APP_API_BASEURL + "/ProfilePics/" + profilePicData}`}
    />
  }

  return (
    <React.Fragment>
      <Modal
        show={profileShowHide}
        onHide={handleProfileShowHide}
        dialogClassName="rt-profile-modal theme-primary"
        centered
        backdrop="static"
      >
        <style>{`
          .modal-backdrop {
            z-index: 1080 !important;
          }
          .modal {
            z-index: 1090 !important;
          }
          .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
          }
          .modal.fade .rt-profile-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .modal.show .rt-profile-modal.modal-dialog {
            transform: scale(1) !important;
          }
          .rt-profile-modal {
            --task-accent: #2563eb;
            --task-soft: #eff6ff;
            width: min(1100px, calc(100vw - 64px)) !important;
            max-width: min(1100px, calc(100vw - 64px)) !important;
            height: auto !important;
          }
          .rt-profile-modal .modal-content {
            border-radius: 12px !important;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
            overflow: hidden !important;
            background: #ffffff !important;
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            max-height: calc(100vh - 60px) !important;
            display: flex !important;
            flex-direction: column !important;
          }
          .rt-profile-modal .modal-header {
            position: relative !important;
            display: block !important;
            padding: 24px 28px 20px 32px !important;
            background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
            border-bottom: 1px solid #edf2f7 !important;
            overflow: hidden !important;
          }
          .rt-profile-modal .modal-header::before {
            content: "" !important;
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            bottom: 0 !important;
            width: 4px !important;
            background: var(--task-accent) !important;
          }
          .rt-profile-modal .rt-header-shell {
            display: flex !important;
            flex-direction: column !important;
            gap: 14px !important;
            width: 100% !important;
          }
          .rt-profile-modal .rt-header-top {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            gap: 18px !important;
            width: 100% !important;
          }
          .rt-profile-modal .rt-header-main {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
            flex: 1 1 auto !important;
          }
          .rt-profile-modal .rt-header-copy {
            display: flex !important;
            flex-direction: column !important;
            gap: 8px !important;
            min-width: 0 !important;
            padding-top: 4px !important;
          }
          .rt-profile-modal .rt-header-icon {
            width: 52px !important;
            height: 52px !important;
            min-height: 52px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: var(--task-accent) !important;
            background: #ffffff !important;
            border: 1px solid var(--task-accent) !important;
            box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
            font-size: 15px !important;
            flex-shrink: 0 !important;
          }
          .rt-profile-modal .rt-modal-title {
            display: inline-flex !important;
            align-items: center !important;
            margin: 0 !important;
            color: #0f172a !important;
            font-size: 18px !important;
            font-weight: 850 !important;
            line-height: 1.2 !important;
            min-width: 0 !important;
          }
          .rt-profile-modal .rt-modal-title-text {
            display: inline-flex !important;
            align-items: center !important;
            gap: 12px !important;
            min-width: 0 !important;
            flex-wrap: wrap !important;
          }
          .rt-profile-modal .rt-modal-title-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 4px 10px !important;
            border-radius: 999px !important;
            font-size: 10px !important;
            font-weight: 800 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
            background: var(--task-soft) !important;
            color: var(--task-accent) !important;
            border: 1px solid #e2e8f0 !important;
          }
          .rt-profile-modal .rt-modal-meta-row {
            display: flex !important;
            align-items: center !important;
            flex-wrap: wrap !important;
            gap: 10px 12px !important;
            margin-top: 0 !important;
            padding-left: 0 !important;
            font-size: 12px !important;
            color: #64748b !important;
          }
          .rt-profile-modal .rt-meta-chip {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            background: #ffffff !important;
            padding: 5px 10px !important;
            border-radius: 8px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            border: 1px solid #e2e8f0 !important;
            box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
          }
          .rt-profile-modal .rt-meta-chip i {
            color: var(--task-accent) !important;
            font-size: 11px !important;
          }
          .rt-profile-modal .rt-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 40px !important;
            height: 40px !important;
            padding: 0 !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            color: #64748b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
          }
          .rt-profile-modal .rt-action-btn:hover {
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            background: #f8fafc !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-profile-modal .rt-action-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
            transition: color 0.2s ease !important;
          }
          .rt-profile-modal .rt-action-btn:hover i {
            color: #ef4444 !important;
          }
          .rt-profile-modal .modal-body {
            padding: 22px !important;
            background: #ffffff !important;
            max-height: calc(100vh - 220px) !important;
            min-height: 0 !important;
            overflow-y: auto !important;
          }
          .rt-profile-modal .modal-footer {
            background: #f8fafc !important;
            border-top: 1px solid #edf2f7 !important;
            padding: 16px 24px !important;
            display: flex !important;
            justify-content: flex-end !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn,
          .rt-profile-modal .rt-profile-edit-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            padding: 9px 20px !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn:hover,
          .rt-profile-modal .rt-profile-edit-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn i,
          .rt-profile-modal .rt-profile-edit-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn:hover i {
            color: #ef4444 !important;
          }
          .rt-profile-modal .rt-profile-edit-btn:hover i {
            color: var(--task-accent) !important;
          }
          .rt-profile-card {
            display: grid !important;
            grid-template-columns: 165px minmax(0, 1fr) !important;
            gap: 18px !important;
            align-items: start !important;
          }
          .rt-profile-aside {
            background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%) !important;
            border: 1px solid #e2e8f0 !important;
            border-radius: 12px !important;
            padding: 16px !important;
            text-align: center !important;
            box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
          }
          .rt-profile-avatar-wrap {
            position: relative !important;
            display: inline-flex !important;
            margin-bottom: 14px !important;
          }
          .rt-profile-avatar-wrap .profilePrev {
            width: 104px !important;
            height: 104px !important;
            object-fit: cover !important;
            border: 3px solid #ffffff !important;
            box-shadow: 0 12px 24px -16px rgba(15,23,42,0.45) !important;
          }
          .rt-profile-modal .profileBtn {
            position: absolute !important;
            right: 2px !important;
            bottom: 4px !important;
            width: 34px !important;
            height: 34px !important;
            border-radius: 50% !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0 !important;
            background: var(--task-accent) !important;
            color: #ffffff !important;
            border: 2px solid #ffffff !important;
            box-shadow: 0 8px 14px -10px rgba(37,99,235,0.8) !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
          }
          .rt-profile-modal .profileBtn:hover {
            transform: translateY(-1px) !important;
            filter: brightness(0.96) !important;
          }
          .rt-profile-modal .profileBtn:has(input:disabled) {
            opacity: 0.65 !important;
            cursor: not-allowed !important;
          }
          .rt-profile-name {
            margin: 0 0 4px !important;
            color: #0f172a !important;
            font-size: 16px !important;
            font-weight: 800 !important;
            line-height: 1.25 !important;
          }
          .rt-profile-email {
            margin: 0 !important;
            color: #64748b !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            word-break: break-word !important;
          }
          .rt-profile-form-card {
            border: 1px solid #e2e8f0 !important;
            border-radius: 12px !important;
            padding: 18px 18px 6px !important;
            box-shadow: 0 1px 3px rgba(15,23,42,0.03) !important;
          }
          .rt-profile-form-head {
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            gap: 12px !important;
            margin-bottom: 18px !important;
            padding-bottom: 14px !important;
            border-bottom: 1px solid #edf2f7 !important;
          }
          .rt-profile-form-title {
            margin: 0 !important;
            font-size: 15px !important;
            font-weight: 800 !important;
            color: #0f172a !important;
          }
          .rt-profile-form-subtitle {
            margin: 3px 0 0 !important;
            font-size: 12px !important;
            color: #64748b !important;
            font-weight: 500 !important;
          }
          .rt-profile-modal label,
          .rt-profile-modal .form-control-label {
            font-size: 11px !important;
            font-weight: 700 !important;
            color: #64748b !important;
            text-transform: uppercase !important;
            letter-spacing: 0.7px !important;
            margin-bottom: 6px !important;
            display: flex !important;
            align-items: center !important;
            gap: 5px !important;
          }
          .rt-profile-modal .form-group {
            margin-bottom: 16px !important;
          }
          .rt-profile-modal .wf-input-wrap {
            position: relative !important;
          }
          .rt-profile-modal .wf-input-icon {
            position: absolute !important;
            left: 12px !important;
            top: 50% !important;
            transform: translateY(-50%) !important;
            color: #94a3b8 !important;
            font-size: 13px !important;
            pointer-events: none !important;
            transition: color 0.2s ease !important;
            z-index: 1 !important;
          }
          .rt-profile-modal .wf-input-wrap:focus-within .wf-input-icon {
            color: var(--task-accent) !important;
          }
          .rt-profile-modal .form-control {
            border-radius: 9px !important;
            border: 1.5px solid #e2e8f0 !important;
            padding: 8px 13px !important;
            font-size: 13px !important;
            color: #1e293b !important;
            background: #ffffff !important;
            transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
            box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
            width: 100% !important;
          }
          .rt-profile-modal .form-control.wf-input-withicon {
            padding-left: 35px !important;
          }
          .rt-profile-modal select.form-control.wf-input-withicon {
            appearance: none !important;
            -webkit-appearance: none !important;
            background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 12px center !important;
            padding-right: 32px !important;
          }
          .rt-profile-modal .form-control::placeholder {
            color: #94a3b8 !important;
          }
          .rt-profile-modal .form-control:hover {
            border-color: #94a3b8 !important;
            box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
          }
          .rt-profile-modal .form-control:focus {
            border-color: var(--task-accent) !important;
            box-shadow: 0 0 0 4px rgba(37,99,235,0.1), 0 2px 6px -1px rgba(37,99,235,0.08) !important;
            outline: none !important;
            background: #fafbff !important;
          }
          .rt-profile-modal fieldset:disabled .form-control {
            background: #f8fafc !important;
            color: #64748b !important;
          }
          .rt-profile-modal .btn-outline-default {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            padding: 8px 16px !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            box-shadow: 0 1px 2px rgba(15,23,42,0.05) !important;
            transition: all 0.2s ease !important;
          }
          .rt-profile-modal .btn-outline-default:hover {
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            background: #f8fafc !important;
            transform: translateY(-1px) !important;
          }
          .rt-profile-modal .rt-profile-form-actions {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 10px !important;
            flex-wrap: wrap !important;
          }
          @media (max-width: 767.98px) {
            .rt-profile-modal {
              width: calc(100% - 20px) !important;
              max-width: calc(100% - 20px) !important;
            }
            .rt-profile-modal .modal-content {
              max-width: 100% !important;
            }
            .rt-profile-card {
              grid-template-columns: 1fr !important;
            }
            .rt-profile-modal .modal-header {
              padding: 20px 20px 18px 24px !important;
            }
            .rt-profile-modal .modal-body {
              padding: 18px !important;
            }
          }
        `}</style>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-user-circle-o" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>My Profile</span>
                      <span className="rt-modal-title-badge">
                        {profileEdit ? "Editing" : "View"}
                      </span>
                    </span>
                  </h2>
                  <div className="rt-modal-meta-row">
                    {userDetails?.performername && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-user" aria-hidden="true" /> {userDetails.performername}
                      </span>
                    )}
                    {userDetails?.performeremail && (
                      <span className="rt-meta-chip" title={userDetails.performeremail}>
                        <i className="fa fa-envelope" aria-hidden="true" /> {userDetails.performeremail}
                      </span>
                    )}
                    {userDetails?.contactNo && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-phone" aria-hidden="true" /> {formatUSPhoneNumber(userDetails.contactNo)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={handleProfileShowHide}
                title="Close Profile"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="rt-profile-card">
            <aside className="rt-profile-aside">
              <div className="rt-profile-avatar-wrap">
                {$imagePreview}
                <label className="profileBtn" title={profileEdit ? "Change profile photo" : "Enable edit to change photo"}>
                  <input
                    type="file"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                    disabled={!profileEdit}
                  />
                  <i className="fa fa-camera" aria-hidden="true"></i>
                </label>
              </div>
              <h3 className="rt-profile-name">{userDetails?.performername || "My Profile"}</h3>
              <p className="rt-profile-email">{userDetails?.performeremail || currentUser?.email || ""}</p>
            </aside>
            <div className="rt-profile-form-card">
              <div className="rt-profile-form-head">
                <div>
                  <h3 className="rt-profile-form-title">Profile Details</h3>
                  <p className="rt-profile-form-subtitle">
                    {profileEdit ? "Update your contact and address information." : "Review your contact and address information."}
                  </p>
                </div>
                {!profileEdit &&
                  <button
                    type="button"
                    className="rt-profile-edit-btn"
                    onClick={handleEditProfile}
                  >
                    <i className="fa fa-edit" aria-hidden="true"></i> Edit
                  </button>}
              </div>
              <MyProfileDetails
                userDetails={userDetails}
                handleSubmit={handleSubmit}
                profileEdit={profileEdit}
                setProfileEdit={setProfileEdit}
                handleEditProfile={handleEditProfile}
              ></MyProfileDetails>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={handleProfileShowHide}
          >
            <i className="fa fa-times" aria-hidden="true" />
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default PartnerProfile;
